import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLocationsStore = defineStore('locations', () => {

    const allLocations = ref([]);
    const selectedLocations = ref([]);
    const showLocations = ref(false);

    function updateLocations(json) {

        if (json.data) {

            allLocations.value = json.data.locations;

        } else {

            allLocations.value = json;

        }

    }

    function updateSelectedLocations(locations) {

        selectedLocations.value = locations;

        if (!selectedLocations.value.length) {

            allLocations.value.map((location) => {
                location.checked = false;
            });

        }

    }

    function setShowLocations(value) {

        showLocations.value = value;

    }

    return {
        allLocations,
        selectedLocations,
        showLocations,
        updateLocations,
        updateSelectedLocations,
        setShowLocations,
    }

})
